import React from "react"
import { Container, Breadcrumb, BreadcrumbItem } from "reactstrap"
import Layout from "./../components/layout"
import SEO from "./../components/seo"

function Legal() {
  return (
    <Layout>
      <SEO />
      <Breadcrumb className="breadCrumb">
        <BreadcrumbItem>
          <a className="breadCrumbLinks" href="/">
            Home
          </a>
        </BreadcrumbItem>
        <BreadcrumbItem active>Legal</BreadcrumbItem>
      </Breadcrumb>
      <Container>
        <h1>Legal</h1>
        <p>
          International Software Products and International Software Products,
          Inc.(collectively known herein as ISP)
        </p>
        <h4>LEGAL NOTICE AND USE</h4>
        <p>
          <strong>Copyright:</strong> Copyright International Software Products
          2008. All rights reserved.
        </p>
        <p>
          ISP hereby authorizes you to view, print, copy and distribute
          information published by ISP on this or any other publicly accessed
          site maintained by ISP as a World Wide Web Site linked to this Legal
          Notice (collectively known herein as the "Sites"), provided that:
        </p>
        <ul>
          <li>
            <strong>(a)</strong> the information may be used internally (by you
            or any third party to whom you distribute it) only for
            informational, non-commercial purposes;
          </li>
          <li>
            <strong>(b)</strong> no fee may be charged for distribution of any
            information to any third party;
          </li>
          <li>
            <strong>(c)</strong> any and all copyright or other proprietary
            notices that appear herein, together with this Legal Notice, must
            appear on all copies that you make or distribute.
          </li>
        </ul>
        <h4>Disclaimers:</h4>
        <p>
          Any product, process or technology published on the Sites may be the
          subject of Intellectual Property rights reserved by ISP, its related
          associated companies or partners and are not licensed hereunder. Any
          software programs and any corrections, updates or new versions of any
          software programs that may be made available by ISP through the Sites
          are provided subject to the additional terms, conditions and
          restrictions indicated in the applicable section of the Sites.
        </p>
        <p>
          If no additional terms are provided on such Sites, any software
          programs or software code is governed by this provision.
        </p>
        <p>
          All information provided via the Sites, including, without limitation,
          any ISP, its related associated companies' or partners' product or
          service plans, software programs, software code, offerings, or
          programs, statements of future directions, "blue papers" or other
          technical or marketing materials (collectively, "Information") is
          intended for informational purposes only and is subject to change or
          withdrawal by ISP at any time without notice. ISP assumes no
          responsibility for the accuracy or completeness of the Information.
          <strong>
            THE INFORMATION IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
            INCLUDING (WITHOUT LIMITATION) ANY IMPLIED WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE OR
            NON-INFRINGEMENT. ISP FURTHER DISCLAIMS ANY LIABILITY IN CONNECTION
            WITH THE SITES OR THE INFORMATION PROVIDED HEREIN. Some
            jurisdictions do not allow the exclusion of implied warranties, so
            the above exclusion may not apply to you. IN NO EVENT WILL ISP BE
            LIABLE TO ANY PARTY FOR ANY DIRECT, INDIRECT, SPECIAL OR OTHER
            CONSEQUENTIAL DAMAGES FOR ANY USE OF THE SITES, THE INFORMATION, OR
            ON ANY OTHER HYPERLINKED WEBSITE, INCLUDING, WITHOUT LIMITATION, ANY
            LOST PROFITS, BUSINESS INTERRUPTION, LOSS OF PROGRAMS OR OTHER DATA
            ON YOUR INFORMATION HANDLING SYSTEM OR OTHERWISE, EVEN IF ISP IS
            EXPRESSLY ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
          </strong>
        </p>
        <h4>Trademarks:</h4>
        <p>
          The International Software Products' logo and the International
          Software Products' product names referenced herein are either
          registered trademarks or trademarks of International Software Products
          or any companies associated or partnered with International Software
          Products or its related corporations.
        </p>
        <h4>Feedback:</h4>
        <p>
          Unless expressly provided otherwise by ISP, all comments, feedback,
          information or materials submitted to ISP through or in association
          with the Sites shall be considered non-confidential and ISP's
          property. By submitting such comments, feedback, information or
          materials to ISP, you agree to a no-charge assignment to ISP of all
          worldwide rights, title and interest in copyrights and other
          intellectual property rights to the comments, feedback, information or
          materials. ISP shall be free to use, copy or distribute such comments,
          feedback, information or materials on an unrestricted basis without
          accounting to you.
        </p>
        <h4>Links to Third Party Sites:</h4>
        <p>
          The Sites may contain hyperlinks to other Web sites controlled by
          parties other than ISP. ISP is not responsible for and does not
          endorse the contents or use of these Web sites.
        </p>
        <h4>Governing Law and Jurisdiction:</h4>
        <p>
          ISP controls the Sites from its offices in Toronto, ON, Canada. You
          agree that any legal action, proceeding or other matters relating to
          your access to, or use of, the Information or the Sites shall be
          governed by Canadian federal law or the laws of the Province of
          Ontario. You may not access, download, use or export the Information
          in violation of Canadian or U.S. export laws or regulations, or in
          violation of any applicable local laws or regulations.
        </p>
        <p>
          If you have any questions concerning legal or other matters described
          above, contact the ISP Legal Department by telephone at (416) 593-5578
          Ext: 225.
        </p>
      </Container>
    </Layout>
  )
}

export default Legal
